import {
  SCHEDULE_SETTINGS_REQUEST,
  SCHEDULE_SETTINGS_SUCCESS,
  SCHEDULE_SETTINGS_FAILURE,
  SCHEDULE_SETTINGS_NOT_FOUND,
  SCHEDULE_SETTINGS_SAVE_REQUEST,
  SCHEDULE_SETTINGS_SAVE_SUCCESS,
  SCHEDULE_SETTINGS_SAVE_FAILURE,
  SCHEDULE_LOCK_REQUEST,
  SCHEDULE_LOCK_SUCCESS,
  SCHEDULE_LOCK_FAILURE,
  SCHEDULE_UNLOCK_REQUEST,
  SCHEDULE_UNLOCK_SUCCESS,
  SCHEDULE_UNLOCK_FAILURE,
} from 'actions';

const initialState = {
  data: null,
  isFetching: false,
  isFetched: false,
  isSaving: false,
  isLocking: false,
  notFound: false,
};

export const scheduleSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_SETTINGS_REQUEST:
      return { ...initialState, isFetching: true };

    case SCHEDULE_SETTINGS_SUCCESS:
      return { ...state, isFetching: false, isFetched: true, data: action.data, notFound: false };

    case SCHEDULE_SETTINGS_NOT_FOUND:
      return { ...initialState, isFetched: true, notFound: true };

    case SCHEDULE_SETTINGS_FAILURE:
      return { ...initialState, isFetched: true };

    case SCHEDULE_SETTINGS_SAVE_REQUEST:
      return { ...state, isSaving: true };

    case SCHEDULE_SETTINGS_SAVE_SUCCESS:
      return { ...state, isSaving: false, data: action.data };

    case SCHEDULE_SETTINGS_SAVE_FAILURE:
      return { ...state, isSaving: false };

    case SCHEDULE_LOCK_REQUEST:
    case SCHEDULE_UNLOCK_REQUEST:
      return { ...state, isLocking: true };

    case SCHEDULE_LOCK_SUCCESS:
      return { ...state, isLocking: false, data: { ...state.data, isScheduleLocked: true } };

    case SCHEDULE_UNLOCK_SUCCESS:
      return { ...state, isLocking: false, data: { ...state.data, isScheduleLocked: false } };

    case SCHEDULE_LOCK_FAILURE:
    case SCHEDULE_UNLOCK_FAILURE:
      return { ...state, isLocking: false };

    default:
      return state;
  }
};
